import { render, staticRenderFns } from "./login_account.vue?vue&type=template&id=6c6aee49&scoped=true"
import script from "./login_account.vue?vue&type=script&lang=js"
export * from "./login_account.vue?vue&type=script&lang=js"
import style0 from "./login_account.vue?vue&type=style&index=0&id=6c6aee49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6aee49",
  null
  
)

export default component.exports